import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { AuthService } from '../auth/auth.service';
import { UserUpdateRequest, AddedProfileHelper } from '../shared/objects/cities';

@Injectable()
export class FormCityProfileService {
  headers = {};

  constructor(private http: HttpClient, private authService: AuthService) {
    this.headers = {
			'Authorization': 'Bearer ' + this.authService.accessToken
		}
  }
  postIndicators(cityID: string,  uuId: any): Promise<UserUpdateRequest>{
      return this.http.post(environment.apiURL + '/admin/updateProfile', cityID, uuId)
          .toPromise()
          .then(response => response)
          .catch(error => {
            return null;
          });
  }
  getIndicators(cityID: string, uuId: any): Promise<AddedProfileHelper>{
    return this.http.get(environment.apiURL + '/admin/addedProfile/' + cityID + '/' + uuId)
        .toPromise()
        .then(response => {
            return response as AddedProfileHelper;
        })
        .catch(error => {
          return null;
        });
 }
}
